const statisticsContainer = {
  padding: { xs: '2rem 3rem', lg: '2rem 7.5rem' },
  color: 'white',
  width: '100%',
};

const statisticsContent = (theme) => ({
  padding: { xs: '2rem 1.5rem', m: '3.375rem 2.75rem' },
  gap: { xs: '3rem', m: '5rem' },
  flex: '1 0 0',
  flexDirection: { xs: 'column', desktop: 'row' },
  borderRadius: '1.25rem',
  width: '100%',
  background: `linear-gradient(180deg, #000000 0%, ${theme.palette.contrast.A700} 100%)`,
});

const statisticsTypography = {
  fontWeight: 500,
  fontSize: { xs: '1.25rem', ipad: '1.5rem' },
  textAlign: 'center',
  width: '100%',
};

export {
  statisticsContainer,
  statisticsContent,
  statisticsTypography,
};
